import React from 'react';
import PropTypes from 'prop-types';

import { FacebookLogin, GoogleLogin } from '@components/SocialLogin';
import { useSelector } from 'react-redux';
import { validateFields, FormErrors } from '@components/Forms/partials/FormErrors';
import TextBox from '@components/Forms/partials/TextBox';
import Button from '@components/Forms/partials/Button';
import { PostData } from '../fetchData';

import '../form.scss';

const validation = {
    email: {
        input_type: 'email',
        required: 1,
        email: 1
    },
    password: {
        input_type: 'password',
        required: 1
    }
};

const LoginComponent = ({ checkout, social, enterprise, actions }) => {
    const [formErrors, setFormErrors] = React.useState({});
    const [loginError, setLoginError] = React.useState('');
    const [submitForm, setFormSubmit] = React.useState(true);

    const { WEB_URL: ENV_WEB_URL, FB_ID, GOOGLE_ID } = useSelector(state => state.initState);

    const postURL = (url, postData) => {
        sessionStorage.clear();

        setFormSubmit(false);

        PostData(ENV_WEB_URL + url, postData)
            .then(result => {
                if (result.code === 'success') {
                    window.user_details = window.btoa(JSON.stringify(result.profileData));
                    if (Storage) {
                        sessionStorage.setItem('login_details', JSON.stringify(result.profileData));
                    }
                    if (checkout === 1 && (!result.data.address || !result.data.city)) {
                        actions.uProfile(result.profileData);
                    } else if (checkout === 1) {
                        actions.setProfileData(result.profileData);
                        actions.payment();
                    } else {
                        actions.profile(result.profileData);
                    }
                } else {
                    setLoginError(result.errors || 'Something went wrong.');
                }
            })
            .finally(() => setFormSubmit(true));
    };

    const getUserLogin = (res, type) => {
        setLoginError('');
        let postData;
        if (type === 'facebook' && res.email) {
            postData = {
                name: res.name,
                client: type,
                email: res.email,
                access_token: res.accessToken,
                id: res.id,
                checkout: checkout ? 1 : 0
            };
        }

        if (type === 'google' && res) {
            postData = {
                name: res.name,
                client: type,
                email: res.email,
                access_token: res.access_token,
                id: res.id,
                checkout: checkout ? 1 : 0
            };
        }

        if (postData) {
            postURL('/social-login', postData);
        } else {
            setLoginError('Unable to login with your social account.');
        }
    };

    const handleChange = event => {
        const obj = {
            name: event.target.name,
            value: event.target.value
        };

        validation[obj.name].value = obj.value;

        setLoginError('') && setFormErrors({});
    };

    const handleSubmit = event => {
        event.preventDefault();

        setLoginError('') && setFormErrors({});

        const validator = validateFields(validation);

        if (validator.isValid) {
            // Form submitted
            const url = '/login';
            const postData = {
                email: event.target.email.value,
                password: event.target.password.value,
                checkout: 1
            };
            postURL(url, postData);
        } else if (validator.errors) {
            setFormErrors(validator.errors);
        }
    };

    const responseFacebook = response => {
        getUserLogin(response, 'facebook');
    };
    const responseGoogle = response => {
        getUserLogin(response, 'google');
    };

    return (
        <div className={`block bg ${checkout ? ' full-height' : ''}`}>
            <div className="header">
                {enterprise ? (
                    <h5 className="heading text-center">Login Using Your OBV Credentials</h5>
                ) : (
                    <h2 className="heading text-center">Please Sign in or Sign up to Continue</h2>
                )}
            </div>
            <div className="content">
                {social === 1 ? (
                    <div>
                        <div className="row social">
                            <div className="col">
                                <FacebookLogin
                                    socialId={FB_ID}
                                    language="en_US"
                                    scope="public_profile,email"
                                    responseHandler={responseFacebook}
                                    xfbml
                                    fields="id,email,name"
                                    version="v2.5"
                                    className="btn btn-block btn-primary"
                                    buttonText="Login With Facebook"
                                />
                            </div>
                            <div className="col">
                                <GoogleLogin
                                    socialId={GOOGLE_ID}
                                    prompt="select_account"
                                    buttonText="Login With Google"
                                    responseHandler={responseGoogle}
                                    className="btn btn-block btn-danger"
                                />
                            </div>
                        </div>

                        <div className="text-center text-muted note">----or with Registered Email----</div>
                    </div>
                ) : (
                    ''
                )}
                <form className="form" onSubmit={handleSubmit} noValidate>
                    <div className="form-group">
                        <TextBox
                            className="form-control"
                            name="email"
                            placeHolder="Email ID"
                            onChange={handleChange}
                            type="email"
                        />
                    </div>
                    <div className="form-group">
                        <TextBox
                            className="form-control"
                            name="password"
                            placeHolder="Password"
                            type="password"
                            onChange={handleChange}
                        />
                    </div>
                    <div className={`error${loginError ? ' show' : ''}`}>
                        <small>{loginError}</small>
                    </div>
                    <FormErrors formErrors={formErrors} />
                    <div className="form-group text-right">
                        <button type="button" className="btn btn-link" onClick={actions.forgotPassword}>
                            Forgot Password
                        </button>
                    </div>
                    <div className="form-group text-center">
                        <Button
                            disabled={!submitForm}
                            className="btn btn-warning"
                            type="submit"
                            activeLoader
                            text="Sign In"
                        />
                    </div>
                    <div className={`form-group text-center ${social === 0 ? 'd-none' : ''}`}>
                        Don`t have account?
                        <button type="submit" onClick={actions.register} className="btn btn-link">
                            Register
                        </button>
                        With Us
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginComponent;

LoginComponent.propTypes = {
    checkout: PropTypes.number,
    social: PropTypes.number,
    enterprise: PropTypes.number,
    actions: PropTypes.shape({
        register: PropTypes.func,
        forgotPassword: PropTypes.func,
        uProfile: PropTypes.func,
        profile: PropTypes.func,
        setProfileData: PropTypes.func,
        payment: PropTypes.func
    }).isRequired
};

LoginComponent.defaultProps = {
    checkout: PropTypes.number,
    social: PropTypes.number,
    enterprise: PropTypes.number
};
